import { C } from "@angular/core/src/render3";

export class AHRIInformation{
    id: string;
    name: string;
    ahriReferenceId: string;
    certifications: string[] = [];
    indoorUnitModel: string;
    indoorUnitType: string;
    product: string;

    constructor(data?) {
        const aHRIInformation = data || {};
        this.id = aHRIInformation.id;
        this.name = aHRIInformation.name;
        this.ahriReferenceId = aHRIInformation.ahriReferenceId;
        this.certifications = aHRIInformation.certifications;
        this.indoorUnitModel = aHRIInformation.indoorUnitModel;
        this.indoorUnitType = aHRIInformation.indoorUnitType;
        this.product = aHRIInformation.product;
    }
}


// WEBPACK FOOTER //
// ./src/app/product-category/models/aHRIInformation.ts